import CatalogueOption from "./CatalogueOption";

export default class Catalogue {
  constructor() {
    this.catalogueOption = new Array<CatalogueOption>();
  }
  key!: string | number;
  catalogueOption!: Array<CatalogueOption>;
}
